<script setup lang="ts">
import { useApiGetHomepageInformations } from '~/apiClient';
import type { BlockItemProps } from '~/components/Block/BlockItem.vue';

// PROPS
defineProps<{
    title?: string;
}>();

// COMPOSABLES
const { tt, tn } = useTypedI18n();
const { data, isLoading, suspense } = useApiGetHomepageInformations();

await suspense();

// DATA
const soldVehicles = computed(() => data.value?.soldVehicles && Math.round(data.value.soldVehicles / 100) * 100);
const countries = computed(() => data.value?.countries && Math.round(data.value.countries / 10) * 10);
const companies = computed(() => data.value?.companies && Math.round(data.value.companies / 100) * 100);
const items = computed<BlockItemProps[]>(() => [
    {
        icon: 'fl:purchase',
        title: tn(soldVehicles.value ?? 1000),
        description: tt('block.stats.purchase'),
        loading: isLoading.value,
    },
    {
        icon: 'fl:markets',
        title: tn(countries.value ?? 70),
        description: tt('block.stats.markets'),
        loading: isLoading.value,
    },
    {
        icon: 'fl:team',
        title: tn(70),
        description: tt('block.stats.team'),
    },
    {
        icon: 'fl:registrations',
        title: tn(companies.value ?? 4000),
        description: tt('block.stats.registrations'),
        loading: isLoading.value,
    },
]);
</script>

<template>
    <BlockTwoCol :title="tt('block.stats.title')" :items="items" :loading="isLoading" />
</template>
